import { PropsWithChildren } from 'react';

import { Box } from '@material-ui/core';

import { TSuccessWrapperProps } from './types';

import { APTypography } from 'common/components';
import { IMG_RESOURCES } from 'common/config/constants/urls';
import { translate } from 'common/config/i18n';

import { cmpStyle } from './styles';

export const SuccessWrapper = ({
  title,
  className,
  children,
}: PropsWithChildren<TSuccessWrapperProps>) => {
  const classes = cmpStyle();

  return (
    <Box className={`${classes.root} ${className}`}>
      <Box className={classes.boxImage}>
        <img src={IMG_RESOURCES.success} alt={translate('deposit_success')} />

        <APTypography textStyle="Typography_Poppins_22px_SemiBold">{title}</APTypography>
      </Box>

      {children}
    </Box>
  );
};
